module.exports = __webpack_public_path__ + "05_face.11d6dce7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer1/05_face.png
// module id = bBuh
// module chunks = 0